<template>
    <div>
        <div class="web-foot">
            <div class="right-nav" @mouseleave="backpidpath">
                <div @mouseenter="getpidpath" data-img="1">
                    <a
                        href="https://xj01.oss-cn-hangzhou.aliyuncs.com/img/（新版）电子商务企业诚信经营承诺书.docx"
                        :class="active == 1 ? 'actives' : ''"
                        ><span v-if="active == 1">诚信<br />承诺书</span
                        ><img
                            src="@imgs/pages/home/book.png"
                            alt=""
                            v-else
                            title="诚信承诺书"
                    /></a>
                </div>
                <div @mouseenter="getpidpath" data-img="2">
                    <a
                        href="javascript:;"
                        :class="active == 2 ? 'actives' : ''"
                    >
                        <span v-if="active == 2">微信<br />公众号</span
                        ><img
                            src="@imgs/pages/home/weixin.png"
                            alt=""
                            v-else
                            title="微信公众号"
                        />
                    </a>
                    <div class="account" v-show="active == 2">
                        <img src="@imgs/pages/home/erweimaa.jpg" alt="" />
                        <p>扫一扫关注</p>
                        <p>官方微信公众号</p>
                    </div>
                </div>
                <div @mouseenter="getpidpath" data-img="3" @click="backtop">
                    <a href="javascript:;" :class="active == 3 ? 'actives' : ''"
                        ><span v-if="active == 3">回到<br />顶部</span
                        ><img
                            src="@imgs/pages/home/backtop.png"
                            alt=""
                            v-else
                            title="回到顶部"
                    /></a>
                </div>
            </div>
            <div class="foot flex-column-center page-type">
                <div class="info">
                    <div class="info-left">
                        <span style="margin:0 0 10px 0">
                            <a href="#/webstatement" target="_blank"  class="a-hover">
                                网站声明
                            </a>
                        </span>
                        <span
                            >友情链接：
                            <a href="http://commerce.ah.gov.cn/" target="_blank"  class="a-hover"
                                >安徽省商务厅</a
                            >
                            <a href="http://www.ahiib.edu.cn/" target="_blank"  class="a-hover"
                                >安徽国际商务职业学院</a
                            ></span
                        >
                    </div>
                </div>
                <div class="line"></div>
                <div class="beian">
                    <div class="website-a">
                        <!-- <a
                            href="https://zfwzgl.www.gov.cn/exposure/jiucuo.html?site_code=bm22000001&url=https%3A%2F%2Fdzswgf.mofcom.gov.cn%2F"
                            target="_blabk"
                            ><img
                                src="@imgs/common/jiucuo.png"
                                alt=""
                                class="zhaocuo"
                        /></a> -->
                        <a @click="skipToAboutus">
                            <img
                                src="@imgs/common/jiucuo.png"
                                alt=""
                                class="zhaocuo"
                        />
                        </a>
                        <!-- <a
                            href="http://bszs.conac.cn/sitename?method=show&id=0726B28348831856E053012819AC9312"
                            target="_blabk"
                            ><img
                                src="@imgs/common/img-dz.png"
                                alt=""
                                class="jsguan"
                        /></a> -->
                    </div>
                    <p>
                        <span>电话：0551-63540603 </span>
                        <span>地址：合肥市政务文化新区祁门路1569号</span>
                    </p>
                    <p>
                        安徽省网商协会 版权所有 Copyright © 2018 All Rights
                        Reserve
                    </p>
                    <p>
                        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"  class="a-hover"
                            >皖ICP备18018432号-2</a
                        >
                    </p>
                    <p>
                        <img src="@imgs/pages/home/gongan.png" alt="" />
                        <a
                            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34010402702015" target="_blank"  class="a-hover"
                            >皖公网安备34010402702015号</a
                        >
                    </p>
                </div>
            </div>
        </div>
        <div class="mb-foot">
            <div class="foot-top">
                <div class="foot-top-left">
                    <img src="@imgs/pages/home/erweimaa.jpg" alt="" />
                </div>
                <div class="foot-top-right">
                    <span
                        >友情链接：
                        <a href="http://commerce.ah.gov.cn/">安徽省商务厅</a>
                        <a href="http://www.ahiib.edu.cn/"
                            >安徽国际商务职业学院</a
                        ></span
                    >
                    <span>电话：0551-63540603 </span>
                    <span>地址：合肥市政务文化新区祁门路1569号</span>
                </div>
            </div>
            <div class="line"></div>
            <div class="beian">
                <span
                    ><a href="https://beian.miit.gov.cn/#/Integrated/index"
                        >皖ICP备18018432号-2</a
                    >
                    安徽省网商协会 版权所有 Copyright © 2018 All Rights
                    Reserve</span
                >
                <span class="flex-row-center"
                    ><img src="@imgs/pages/home/gongan.png" alt="" />
                    <p>
                        <a
                            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34010402702015"
                            >皖公网安备34010402702015号</a
                        >
                    </p></span
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'web-foot',
  data() {
    return {
      active: 0,
      rightLeave: 0,
      interval: null,
    }
  },
  methods: {
    skipToAboutus(){
      this.$router.push('/aboutus')
      window.scrollTo(0,800)
    },
    getpidpath(e) {
      let v = e.target.attributes[1].nodeValue
      this.active = v
    },
    backpidpath() {
      this.active = 0
    },
    docScroll() {
      let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop
      if (scrollTop > 300) {
        this.rightLeave = 1
      } else {
        this.rightLeave = 0
      }
    },
    backtop() {
      if (this.interval) {
        clearInterval(this.interval)
      }
      let _this = this
      this.interval = setInterval(function () {
        let scrollTop =
                    window.pageYOffset ||
                    document.documentElement.scrollTop ||
                    document.body.scrollTop
        scrollTop -= 30
        if (scrollTop < 0) {
          scrollTop = 0
          window.scroll(0, scrollTop)
          clearInterval(_this.interval)
        }
        window.scroll(0, scrollTop)
      }, 0)
    },
  },
  mounted() {
    window.addEventListener('scroll', this.docScroll, false)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.docScroll)
  },
}
</script>

<style lang="less" scoped>
.web-foot {
    // margin-top: -0.26rem;
    @media all and (min-width: 750px) {
        background-color: #1f2122;
        .foot {
            padding: 0.154687rem 0 0.214844rem;
            margin: 0 2.3rem;
            font-size: 0.18rem;
            line-height: 0.12rem;
            color: #ffffff;
            .info {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .info-left {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    align-items: flex-start;
                    width: 100%;
                    font-size: 0.120312rem;
                    a {
                        margin-right: .085937rem;
                        color: #fff;
                        text-decoration: none;
                        &:hover {
                          color: #ed5a65;
                        }
                    }
                    span {
                        display: block;
                        width: 100%;
                        text-align: center;
                    }
                }
            }
            .line {
                width: 12rem;
                height: 1px;
                background-color: #ffffff;
                margin: 0.085937rem 0;
            }
            .beian {
                position: relative;
                display: flex;
                width: 100%;
                font-size: 0.120312rem;
                flex-direction: column;
                .website-a {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    transform: translateX(304px);
                    .zhaocuo {
                        width: 0.730469rem;
                        height: 0.365234rem;
                    }
                    .jsguan {
                        width: 0.6875rem;
                        height: 0.6875rem;
                    }
                }
                a {
                    text-decoration: none;
                    color: #fff;
                }
                p {
                    line-height: 30px;
                    > img {
                        margin-right: 5px;
                        width: 0.171875rem;
                        height: 0.171875rem;
                        vertical-align: middle;
                    }
                }
            }
            // 鼠标放到a链接上呈现的颜色
            .a-hover:hover {
                color: #ed5a65;
            }
        }

        .right-nav {
            position: fixed;
            z-index: 999;
            border-radius: 0.06875rem;
            border: solid 0.01rem #b6ceec;
            right: 0.085937rem;
            top: 50%;
            transform: translateX(-50%);
            background-color: #7f7f7f;
            display: flex;
            flex-direction: column;
            .actives {
                background-color: #4878b3;
                color: #fff;
                font-size: 0.120312rem;
                border-radius: 0.06875rem;
                animation: hoverStyle 0.5s;
            }
            a {
                height: 0.515625rem;
                width: 0.515625rem;
                text-decoration: none;
                color: #333;
                display: flex;
                flex-wrap: wrap;
                align-content: center;
                justify-content: center;
                &:hover {
                    color: #fff;
                }
            }
            > div {
                flex: 1;
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                &:hover {
                    cursor: pointer;
                }
                &:nth-of-type(2) {
                    border-top: solid 0.01rem #fff;
                    border-bottom: solid 0.01rem #fff;
                    position: relative;
                    .account {
                        position: absolute;
                        left: 0;
                        height: 1.5rem;
                        width: 1.2rem;
                        top: 0rem;
                        display: flex;
                        justify-content: center;
                        flex-wrap: wrap;
                        align-content: center;
                        background: #eeeeee;
                        transform: translateX(-1.21rem);
                        img {
                            height: 0.8rem;
                            width: 0.8rem;
                            margin-bottom: 0.1rem;
                        }
                        p {
                            width: 100%;
                            color: #333333;
                            margin: 0;
                        }
                    }
                    a {
                        &.actives {
                            border-radius: 0;
                        }
                    }
                }
                p {
                    font-size: 0.103125rem;
                    line-height: 0.18rem;
                    margin: 0;
                    margin-top: 0.1rem;
                }
            }
            img {
                height: 0.257812rem;
                width: 0.257812rem;
            }
        }
    }
}
@media all and (min-width: 750px) {
    .mb-foot {
        display: none;
    }
}
@media all and (max-width: 750px) {
    .web-foot {
        display: none;
    }
    .mb-foot {
        width: 7.5rem;
        box-sizing: border-box;
        overflow: hidden;
        height: 3.95rem;
        background-image: linear-gradient(154deg, #4d96f2 0%, #316fee 100%);
        .foot-top {
            padding: 0.5rem 0.2rem 0rem 0.2rem;
            display: flex;
            justify-content: center;
            .foot-top-left {
                height: 1.7rem;
                width: 1.7rem;
                margin-right: 0.2rem;
                img {
                    height: 1.7rem;
                    width: 1.7rem;
                }
            }
            .foot-top-right {
                align-items: left;
                a {
                    text-decoration: none;
                    color: #fff;
                    &:hover {
                        color: #551a8b;
                        text-decoration: underline;
                    }
                }
                span {
                    display: block;
                    line-height: 0.3rem;
                    letter-spacing: 0rem;
                    font-size: 0.24rem;
                    font-weight: normal;
                    font-stretch: normal;
                    height: 0.6rem;
                    color: #fefefe;
                    text-align: left;
                    a {
                        letter-spacing: 0;
                    }
                }
            }
        }
        .line {
            width: 7.5rem;
            height: 1px;
            background-color: #ffffff;
            margin: 0.17rem 0;
        }
        .beian {
            span {
                display: block;
                font-family: SourceHanSansCN-Regular;
                font-size: 0.16rem;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0rem;
                color: #ffffff;
                a {
                    text-decoration: none;
                    color: #f6f6f6;
                }
            }
            .flex-row-center {
                display: flex;
                align-items: center;
            }
        }
    }
}
// 右侧侧边栏鼠标悬浮动画
@keyframes hoverStyle {
    25% {
        transform: scale(1.2);
    }
    75% {
        transform: scale(0.8);
    }
}
</style>